<template>
  <div :id="id">
    <div class="cursor-pointer" @click="handleIconClick()">
      <aha-icon
        name="kebab-menu"
        width="18"
        height="18"
        viewBox="0 0 14 14"
      />
    </div>
    <aha-context-menu
      ref="context-menu"
      :target="id"
      :x="targetX"
      :y="targetY"
    >
      <aha-context-menu-header>
        {{ presentation.name }}
      </aha-context-menu-header>

      <aha-context-menu-item @click="handleClickToRename()">
        <aha-icon
          class="text-base-70"
          name="edit"
          viewBox="0 0 22 22"
          width="16"
          height="16"
        />
        <span>{{ $i18nPresenter.t("Rename") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item @click="handleClickShareToEdit()" v-if="inviteToEditVisible">
        <aha-icon
          class="text-base-70"
          name="share-collab"
          width="16"
          height="16"
          viewBox="0 0 18 16"
        />
        <span>{{ $i18nPresenter.t("Invite to edit") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item @click="handleClickInviteParticipants()">
        <aha-svg
          v-if="!isInvitingParticipant"
          class="text-base-70"
          name="share"
          width="17"
          height="17"
          viewBox="0 0 24 24"
        />
        <aha-spinner v-else />
        <span>{{ $i18nPresenter.t("Share") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        class="flex report-menu-item"
        @click="handleClickReport"
      >
        <aha-svg
          name="multiple-choice-w"
          class="text-base-70"
          width="16"
          height="16"
          view-box="0 0 30 30"
        />
        <span>{{ $i18nPresenter.t("Report") }}</span>
      </aha-context-menu-item>
      <div class="my-1 border-b border-solid border-base-30" @click.stop />
      <aha-context-menu-item
        @click="handleResetResultsItemClick()"
      >
        <aha-icon
          v-if="!isOpeningClearDataModal"
          class="text-base-70"
          name="reset"
        />
        <aha-spinner v-if="isOpeningClearDataModal" />
        <span>{{ $i18nPresenter.t("Reset results") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        @click="handleMoveToItemClick()"
        v-if="presentation.User.id === $store.state.currentUser.id"
        class="context-menu-item md:hidden lg:hidden xl:hidden"
      >
        <aha-svg class="text-base-70" name="move" />
        <span>{{ $i18nPresenter.t("Move to") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item @click.stop="handleDuplicatePresentation()">
        <aha-icon
          name="duplicate"
          class="text-base-70"
          width="18"
          height="18"
          viewBox="0 0 20 20"
          v-if="!isPresenationDuplicating"
        />
        <aha-spinner v-else />
        <span>{{ $i18nPresenter.t("Duplicate") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        v-if="isAllowToCopyAcrossWorkspace()"
        @click="handleClickCopyToWorkspace"
      >
        <aha-icon
          name="copy-to-workspace"
          class="text-base-70"
          width="18"
          height="18"
          viewBox="0 0 20 20"
        />
        <span>{{ $i18nPresenter.t("Copy to workspace...") }}</span>
      </aha-context-menu-item>
      <div class="block my-1 border-b border-solid border-base-30 md:hidden" @click.stop />
      <aha-context-menu-item
        class="flex md:hidden"
        @click="handleClickViewDetail"
      >
        <aha-svg
          name="info-circle"
          class="text-base-70"
          width="14"
          height="14"
          view-box="0 0 18 18"
        />
        <span>{{ $i18nPresenter.t("View Detail") }}</span>
      </aha-context-menu-item>

      <div
        v-if="presentation.User.id === $store.state.currentUser.id || workingMode !== 'team'"
        class="my-1 border-b border-solid border-base-30"
        @click.stop
      />
      <aha-context-menu-item
        v-if="showDeletePresentationItem"
        @click="handleDeletePresnItemClick()"
        class="text-red-100"
      >
        <aha-svg name="delete" />
        <span>{{ $i18nPresenter.t("Delete") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        v-if="presentation.User.id !== $store.state.currentUser.id && workingMode !== 'team'"
        @click="handleLeavePresentationItemClick()"
        class="text-red-100"
      >
        <aha-svg name="logout" />
        <span>{{ $i18nPresenter.t("Leave") }}</span>
      </aha-context-menu-item>
    </aha-context-menu>

    <modal-clear-data
      :presentation="presentation"
      v-if="isShowingClearDataModal"
      @hide="handleHideClearDataModal()"
      :title="resetResultsHeading"
      :defaultModal="true"
    />

    <modal-delete-presentations
      :deleted-presentations="[presentation]"
      v-if="showingDelelePresentationsModal"
      @hide="handleHideDeletePresentations()"
    />

    <ModalLeavePresentations
      :leave-presentations="[presentation]"
      v-if="showingLeavePresentationsModal"
      @hide="handleHideLeavePresentations()"
    />
    <modal-move-presentations
      :selected-presentations="[presentation]"
      v-if="isShowingMovePresnModal"
      @hide="handleHideMovePresentation()"
    />

    <EditorShareV2Modal
      :presentation="presentation"
      v-if="isShowShareV2Popup"
      @hideModal="isInviteParticipantsModalShowing = false"
      source="presentations-list"
    ></EditorShareV2Modal>
    <InviteParticipantsModal
      v-if="!isTreatmentShareV2 && isInviteParticipantsModalShowing"
      :presentation="presentation"
      @hide="isInviteParticipantsModalShowing = false"
    />
    <CopyToWorkspaceModal
      v-if="isCopyToWorkspaceModalShowing && currentAccount.id"
      :presentation="presentation"
      @hide="isCopyToWorkspaceModalShowing = false"
    />
    <ShareToEditModal
      v-if="isShareToEditModalShowing && workingMode !== 'team'"
      :presentation="presentation"
      @hide="isShareToEditModalShowing = false"
    />
    <ShareToTeamForEditModal
      :presentation="presentation"
      v-if="isShareToEditModalShowing && workingMode === 'team'"
      :teamName="currentAccount.name"
      @hide="isShareToEditModalShowing = false"
    />
    <PresentationDetail
      v-if="isShowingPresentationDetail"
      :presentation="presentation"
      @hide="handleHideViewDetails"
    />
    <RenamePresentationModal
      v-if="isShowRenameModal"
      :presentation="presentation"
      @hide="isShowRenameModal = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import socketHelper from '@/helpers/socket/socket-helper'

// utils
import utils from '@/util'

// constants
import constants from '@/constant'

// configs
import configs from '@/config'

// eventbus
import EventBus from '@/eventBus'

// modals
import ModalClearData from '../../modals/ClearData.vue'
import ModalDeletePresentations from '../../modals/DeletePresentations.vue'
import ModalLeavePresentations from '../../modals/LeavePresentations.vue'
import ModalMovePresentations from '../../modals/MovePresentations.vue'
import InviteParticipantsModal from '../../modals/InviteParticipantsModal.vue'
import ShareToEditModal from '../../modals/ShareToEditModal.vue'
import ShareToTeamForEditModal from '../../modals/ShareToTeamForEdit.vue'
import CopyToWorkspaceModal from '../../modals/CopyToWorkspace.vue'
import RenamePresentationModal from '@/components-v2/modals/RenamePresentationModal.vue'
import PresentationDetail from './PresentationDetail.vue'
import mixpanelUtils from '@/utils/mixpanel.utils'
import EditorShareV2Modal from '@/components-v2/modals/EditorShareV2Modal.vue'

const { eventCategories } = constants

export default {
  components: {
    EditorShareV2Modal,
    ModalClearData,
    ModalDeletePresentations,
    ModalMovePresentations,
    InviteParticipantsModal,
    ShareToEditModal,
    ShareToTeamForEditModal,
    CopyToWorkspaceModal,
    ModalLeavePresentations,
    PresentationDetail,
    RenamePresentationModal,
  },
  props: {
    presentation: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
    rightClickEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowingClearDataModal: false,
      isPresenationDuplicating: false,
      isInvitingParticipant: false,
      isOpeningClearDataModal: false,
      showingLeavePresentationsModal: false,
      showingDelelePresentationsModal: false,
      isShowingMovePresnModal: false,
      targetX: null,
      targetY: null,
      isShareToEditModalShowing: false,
      isCopyToWorkspaceModalShowing: false,
      isInviteParticipantsModalShowing: false,
      isShowingPresentationDetail: false,
      isShowRenameModal: false,
      text_Reset: this.$i18nPresenter.t('Reset'),
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
      currentUser: (state) => state.currentUser,
      workingMode: (state) => state.workingMode,
      currentAccount: (state) => state.currentAccount,
    }),
    ...mapGetters(['isTreatmentShareV2']),
    isShowShareV2Popup() {
      return this.isInviteParticipantsModalShowing &&
          this.isTreatmentShareV2
    },
    inviteToEditVisible() {
      return this.currentUser.identifyProvider !== 'skoletube' && !this.isTreatmentShareV2
    },
    resetResultsHeading() {
      return `${this.text_Reset} '${this.presentation.name}'?'`
    },
    isUserNotEditor() {
      return this.presentation.userId !== this.currentUser.id &&
        this.presentation.takenOverBy !== this.currentUser.id
    },
    isResetResultsButtonDisabled() {
      return !this.presentation.hasResults || this.presentation.participantsCount === 0 ||
        this.isUserNotEditor
    },
    showDeletePresentationItem() {
      return (this.presentation.User.id === this.$store.state.currentUser.id
        || this.$store.state.currentUser.accountRole === constants.workspace.OWNER
        || this.$store.state.currentUser.accountRole === constants.workspace.ADMIN)
    },
  },
  mounted() {
    if (this.rightClickEnabled) {
      EventBus.$on('open-kebab-presentation', ({ id, x, y }) => {
        if (id !== this.presentation.id) {
          return
        }

        this.targetX = x
        this.targetY = y
        this.handleIconClick(true)
      })
    }
  },
  destroyed() {
    EventBus.$off('open-kebab-presentation')
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setErrorOnInternalServerAction']),
    ...mapActions('presentationReport', ['selectPresentationAction', 'openReportPanelAction', 'subscribeReportAction']),
    handleIconClick(exact) {
      if (!exact) {
        this.targetX = null
        this.targetY = null
      }

      this.isShowingClearDataModal = false
      this.showingDelelePresentationsModal = false
      this.$refs['context-menu'].show()
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'Presentation Kebab Menu > Open',
        null,
        null,
        {
          trigger: exact ? 'contextmenu' : 'click',
          presentationId: this.presentation.id,
          isTeamPresentations: this.$store.state.workingMode === constants.workspace.TEAM,
        },
      )
    },
    async handleResetResultsItemClick() {
      this.isOpeningClearDataModal = true
      const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      this.isOpeningClearDataModal = false
      if (!hasPerm) return
      this.isShowingClearDataModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Clear result > Open modal')
    },
    async handleDeletePresnItemClick() {
      this.showingDelelePresentationsModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Delete presentation > Open modal')
    },
    handleLeavePresentationItemClick() {
      this.showingLeavePresentationsModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Leave presentation > Open modal')
    },
    async handleHideClearDataModal() {
      this.isShowingClearDataModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Clear result > Close modal')
    },
    async handleHideDeletePresentations() {
      this.showingDelelePresentationsModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Delete presentation > Close modal')
    },
    handleHideLeavePresentations() {
      this.showingLeavePresentationsModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Leave presentation > Close modal')
    },
    handleHideMovePresentation() {
      this.isShowingMovePresnModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Move presentation > Close modal')
    },
    handleMoveToItemClick() {
      this.isShowingMovePresnModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Move presentation > Open modal')
    },
    handleClickShareToEdit() {
      this.isShareToEditModalShowing = true

      const isSelfCreatedTeam = this.$store.state.workingMode === constants.workspace.PERSONAL ?
        null : (
          this.$store.state.currentAccount.createdFrom === 'presenter'
        )
      const teamId = this.$store.state.workingMode === constants.workspace.PERSONAL ?
        null : (
          this.$store.state.currentAccount.id
        )
      const presentationId = this.presentation.id
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST,
        'Presentation Kebab Menu > Open Invite to edit Dialog',
        '',
        '',
        {
          isSelfCreatedTeam,
          teamId,
          presentationId,
        })
    },
    handleClickViewDetail() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Open View Detail')
      this.isShowingPresentationDetail = true
      document.body.classList.add('no-scroll') // avoid background scrolling
    },
    handleClickReport() {
      this.selectPresentationAction({ presentation: this.presentation })
      if (this.presentation && this.presentation.uniqueAccessCode) {
        socketHelper.joinRoomPresentation(this.presentation.uniqueAccessCode)
        this.subscribeReportAction(this.presentation)
      }
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Open Report', this.presentation.id, null, 'Presentation List kebab menu')

      this.openReportPanelAction()
      if (window.innerWidth < 768) {
        document.body.classList.add('no-scroll') // avoid background scrolling
      }
    },
    handleHideViewDetails() {
      this.isShowingPresentationDetail = false
      document.body.classList.remove('no-scroll')
    },
    async handleClickInviteParticipants() {
      this.isInvitingParticipant = true
      const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      this.isInvitingParticipant = false
      if (!hasPerm) return
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Open Share menu')
      this.isInviteParticipantsModalShowing = true
    },
    async handleDuplicatePresentation() {
      this.isPresenationDuplicating = true
      const isOwner = this.presentation.userId === this.currentUser.id
      try {
        if (isOwner) {
          await this.$http.post(configs.api.duplicatePresentation, {
            name: this.presentation.name,
            id: this.presentation.id,
          })
        } else if (this.$route.name === 'TeamFolderDetail') {
          // duplicate inside folder team
          await this.$http.post(configs.api.copyPresentation, {
            id: this.presentation.shareCode,
            name: this.presentation.name,
            fromWorkspace: true,
            isFolderIdRemained: true,
          })
        } else {
          // Copy, duplicate for sharewithme and team root
          await this.$http.post(configs.api.copyPresentation, {
            id: this.presentation.shareCode,
            name: this.presentation.name,
            fromWorkspace: (this.$route.name === 'Team'),
          })
        }

        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Create new presentation', 'Presentation kebab menu > Make a copy', this.presentation.id, {
          sourcePresentationId: this.presentation.id,
          ...mixpanelUtils.getPresentationContext(this.presentation),
        })
        utils.showToastSuccess(this.$i18nPresenter.t('Presentation duplicated.'))

        EventBus.$emit('reload-presentations-and-folders')
      } catch (error) {
        this.$refs['context-menu'].hide()
        this.setErrorOnInternalServerAction(`${this.$i18nPresenter.t('Cannot duplicate presentation:')} ${this.presentation.name}`)
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation > Duplicate > Failed')
        this.isPresenationDuplicating = false

        throw error
      }
    },
    handleClickCopyToWorkspace() {
      this.isCopyToWorkspaceModalShowing = true
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'Presentation Kebab Menu > Open copy to anorther workspace modal',
        null,
        null,
        {
          presentationId: this.presentation.id,
          isTeamPresentations: this.$store.state.workingMode === constants.workspace.TEAM,
        },
      )
    },
    handleClickToRename() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Rename > Open modal')
      this.isShowRenameModal = true
    },
    isAllowToCopyAcrossWorkspace() {
      if (this.currentUser && !this.currentUser.accountId) return false
      if (this.currentUser.permissions &&
        // eslint-disable-next-line max-len
        !this.currentUser.permissions.includes(constants.permissions.COPY_PRESENTATIONS_ACROSS_WORKSPACES)) {
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1100px) {
  .report-menu-item {
    display: none;
  }
}
</style>
